export class SignUpDto {
    public name;
    public lastName;
    public username;
    public email;
    public password;
    public token;

    constructor() {
    }
}